import { FCX } from "@datassential/platform-ui-lib";
import { ViewConfig } from "./PopularityTrendGapChart.constants";
import { PlottableKeyword, formatMetricPercent } from "./PopularityTrendGapChart.helpers";

interface Props {
    keyword: PlottableKeyword;
    config:  ViewConfig;
}

/**
 * Tooltip body for a hovered scatter dot: the keyword name plus both active-view
 * metric values, each labeled by its metric name (AC: never show bare percentages).
 */
const PopularityTrendGapTooltip: FCX<Props> = ({ keyword, config }) => (
    <div className="PopularityTrendGapChart__tooltip">
        <div className="PopularityTrendGapChart__tooltip-name">{keyword.wordName}</div>
        <div className="PopularityTrendGapChart__tooltip-row">
            <span className="PopularityTrendGapChart__tooltip-metric">{config.xLabel}:</span>
            <span className="PopularityTrendGapChart__tooltip-value">{formatMetricPercent(keyword.x)}</span>
        </div>
        <div className="PopularityTrendGapChart__tooltip-row">
            <span className="PopularityTrendGapChart__tooltip-metric">{config.yLabel}:</span>
            <span className="PopularityTrendGapChart__tooltip-value">{formatMetricPercent(keyword.y)}</span>
        </div>
    </div>
);

export default PopularityTrendGapTooltip;
